import { QuestDefinition } from './types';

/**
 * Quest definition for the Outline Create tool (OutlineTool / 'outline_create').
 *
 * The tool is driven by Redux room selection — picking rooms (in 3D or in the
 * left panel) refreshes a live preview; Enter commits the preview as one or
 * more outlines, one per connected component (interior voids become holes).
 */
export const outlineCreateQuest: QuestDefinition = {
  toolName: 'outline_create',
  states: {
    idle: 'select rooms to include, then press Enter to create the outline',
    has_selection: 'press Enter to create the outline, or click more rooms to add them',
  },
  defaultKey: 'select rooms to include, then press Enter to create the outline',
};
